/* eslint-disable import/named */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import type {ChangeEvent, MouseEvent} from 'react';
import {useEffect, useState} from 'react';
import {
	Form,
	InputGroup,
	Button,
	Tooltip,
	OverlayTrigger,
} from 'react-bootstrap';
import {confirmAlert} from 'react-confirm-alert';
import {useGetReMapSetsAllQuery} from 'services';
import type {ReMapBD, Xml2Js, ReMap} from 'interfaces';
import {cleanObjectBeforeXML} from 'utils';
import {toast} from 'react-toastify';
import type {TSelectMultiple} from 'types/general';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

type TProps = {
	onChange: (arg: Xml2Js) => void;
	rowData: Xml2Js;
	isEdit: boolean;
};

const TransformationsForm = (props: TProps) => {
	const [state, setState] = useState<any[]>([]);
	const [selectedValues, setSelectedValues] = useState([]);

	const {data = {}, isLoading} = useGetReMapSetsAllQuery(undefined);
	let getReMapData: any = [];

	if (isLoading) {
		getReMapData = [];
	} else if (Array.isArray(data) && data.length > 0) {
		getReMapData = data;
	} else {
		getReMapData = [];
	}

	useEffect(() => {
		// copy temporal variable
		const tmp = cleanObjectBeforeXML(
			state ? JSON.parse(JSON.stringify(state)) : defaultFormData(),
		);

		props.onChange({
			transformations: cleanObjectBeforeXML(JSON.parse(JSON.stringify(tmp))),
		} as never);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state]);

	useEffect(() => {
		if (props.isEdit && props?.rowData) {
			let transformations: ReMap[] = defaultFormData();
			if (props?.rowData?.transformations?.[0]?.ReMap) {
				transformations = props.rowData.transformations?.[0]?.ReMap;
				setState(transformations);
				// eslint-disable-next-line react-hooks/exhaustive-deps
			}
		}
	}, [props.rowData, props.isEdit]);

	/**
	 * The function `handleAddReset` adds a new namePolicy object to an array and updates the checkbox
	 * array accordingly.
	 * @param e - The parameter "e" is of type MouseEvent<HTMLElement>. It represents the event object
	 * generated when the click event is triggered on an HTML element.
	 */
	const handleAddReference = (e: MouseEvent<HTMLElement>) => {
		e.preventDefault();

		const newObjReMap = {
			_: null,
			$: {
				pre: 'false',
			},
		};

		const hasNullUnderscore = state.some((item: ReMap) => item._ === null);

		if (hasNullUnderscore) {
			toast.error('Name reference fields cannot be null');
		} else {
			const tmp = [...state, newObjReMap];
			setState(tmp);
		}
	};

	/**
	 * The handleRemove function triggers a confirmation modal with options for removing an element.
	 * @param e - MouseEvent<HTMLElement> - This is the event object that is passed when the remove event
	 * is triggered. It contains information about the event, such as the target element that triggered
	 * the event.
	 * @param {number} i - The parameter "i" is a number that represents the index of an element.
	 */
	const handleRemoveTransform = (e: MouseEvent<HTMLElement>, i: number) =>
		confirmAlert(optionsRemoveReMap(e, i));

	/**
	 * The function `optionsRemoveNamePolicy` returns an object with properties for a confirmation modal
	 * dialog, including a title, message, buttons, and various configuration options.
	 * @param e - The `e` parameter is the MouseEvent object that triggered the event. It contains
	 * information about the event, such as the target element and the coordinates of the mouse pointer.
	 * @param {number} i - The parameter `i` is the index of the item that you want to remove. It is used
	 * in the `handleRemoveNamePolicy` function to identify which item to remove.
	 */
	const optionsRemoveReMap = (e: MouseEvent<HTMLElement>, i: number) => ({
		title: 'Do you really want to remove?',
		message: 'The action must be saved for the change to persist.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					try {
						handleRemoveReMap(e, i);
						toast.success('Deleted Successfully!');
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	const handleRemoveReMap = (e: MouseEvent<HTMLElement>, key: number) => {
		e.preventDefault();

		// inputs
		const tmp = state.filter((item, i) => i !== key);
		const rowData = {...props?.rowData};

		if (!rowData.transformations && tmp) {
			rowData.transformations = [];
		}

		if (rowData?.transformations?.[0]) {
			rowData.transformations[0] = {
				...rowData.transformations[0],
				ReMap: tmp,
			};
		} else {
			rowData.transformations[0] = {
				ReMap: tmp,
			};
		}

		if (rowData.transformations && !tmp) {
			rowData.transformations = [];
		}
		setState(tmp);
		props.onChange(rowData);
	};

	const getItemValue = (reMap: any) => {
		if (!reMap) {
			return null;
		} else if (typeof reMap === 'object') {
			return reMap._;
		} else {
			return reMap;
		}
	};

	/**
	 * This function updates the selected values and the policyCtrlReqTrigger property in the formData
	 * object based on the user's multiple selection.
	 * @param {TSelectMultiple[]} selected - The `selected` parameter is an argument passed to the
	 * `handleSelectChange` function. It is expected to be an array of objects representing the
	 * selected options in a multiple select dropdown.
	 */
	const handleSelectChange = (selected: any, idx: number) => {
		setSelectedValues(selected as never);

		const tmp = state.map((el, index) =>
			index === idx ? {...el, _: selected.value} : el,
		);

		setState(tmp as never);
	};

	const getSelectedValue = (item: any) => {
		const valueItem = getItemValue(item);
		const selectedVal = getReMapData.find(
			(remapItem: ReMapBD) => remapItem.nameRemap === valueItem,
		);
		return selectedVal
			? {value: selectedVal.nameRemap, label: selectedVal.nameRemap}
			: null;
	};

	const handleChange = (e: ChangeEvent<HTMLInputElement>, idx: number) => {
		const {checked} = e.target;

		const tmp = state?.map((el, index) => {
			if (index === idx) {
				return {
					...el,
					$: {
						...el.$,
						pre: checked ? true : false,
					},
				};
			}

			return el;
		});

		setState(tmp as never);
	};

	return (
		<div className="mb-3">
			<div className="row bg-gray rounded pt-3 mx-0 mb-3">
				{/* 4 row */}
				{state &&
					state?.map((item: any, idx: number) => (
						<div className="mt-3" key={idx}>
							<div className="col-xs-12 d-flex justify-content-between align-items-center mb-3">
								<div className="d-flex justify-content-center flex-grow-1">
									<b>{`Reference #${idx + 1}`}</b>
								</div>
								<OverlayTrigger
									overlay={
										<Tooltip id="tooltip-disabled">{`Delete Reference #${
											idx + 1
										}`}</Tooltip>
									}>
									<Button
										type="button"
										className="border-0 bg-transparent d-inline ml-auto"
										onClick={(e: MouseEvent<HTMLElement>) =>
											handleRemoveTransform(e, idx)
										}>
										<i className="bi-1 bi-trash-fill text-danger" />
									</Button>
								</OverlayTrigger>
							</div>
							<div className="col-xs-12">
								<div className="d-flex align-items-center mb-3">
									<div className="col-xs-12 col-md-2">
										<Form.Check
											name="predefined"
											type="switch"
											label="PRE"
											id="custom-switch"
											className="ml-4 mt-2 mr-4"
											onChange={e => handleChange(e as never, idx)}
											checked={JSON.parse(item?.$?.pre ?? 'false')}
										/>
									</div>
									<div className="col-xs-12 col-md-10">
										<InputGroup className="mb-3" style={{height: 35}}>
											<Select
												placeholder="Name Reference"
												components={animatedComponents}
												name="reMap"
												value={getSelectedValue(item)}
												onChange={selectOption =>
													handleSelectChange(selectOption, idx)
												}
												options={getReMapData.map((itemRm: ReMapBD) => ({
													value: itemRm.nameRemap,
													label: itemRm.nameRemap,
												}))}
												styles={{
													container: base => ({
														...base,
														flex: 1,
													}),
													control: baseStyles => ({
														...baseStyles,
														borderColor: '#ced4da',
													}),
												}}
											/>
										</InputGroup>
									</div>
								</div>
							</div>
						</div>
					))}
				{/* end 4 row */}
			</div>
			<div className="d-flex justify-content-center align-items-center mt-3">
				<Button
					type="button"
					className="btn btn-labeled btn-primary btn-sm collapsed"
					onClick={handleAddReference}>
					<span className="btn-label mr-2">
						<i className="bi-1 bi-plus-square" />
					</span>
					{/* Noncompliant: ambiguous spacing */}
					Add new Reference Transformation
				</Button>
			</div>
		</div>
	);
};

const defaultFormData = (): ReMap[] => [
	{
		_: '',
		$: {
			pre: 'false',
		},
	},
];

export default TransformationsForm;
